import AxiosError from "./axios13.js";
import utils from "./axios2.js";
function CanceledError(message, config, request) {
  AxiosError.call(this, message == null ? "canceled" : message, AxiosError.ERR_CANCELED, config, request);
  this.name = "CanceledError";
}
utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});
export {
  CanceledError as default
};
//# sourceMappingURL=axios8.js.map
